export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";